import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const CommonAbout = () => {
  const { t } = useTranslation();
  return (
    <div className="common-about-warp" id="scene_about">
      <div className="common-about-bg">
        <img src={"//files.authing.co/authing-website/solution-about-banner.png"} alt="authing about" />
      </div>
      <div className="common-about">
        <div className="title">{t("common.about.title")}</div>
        <div className="overview">
          <p>{t("common.about.description1")}</p>
        </div>
        <div className="descript-warp">
          <div className="descript">
            <p>{t("common.about.description2")}</p>
          </div>
          <div className="descript-img-box">
            <div className="descript-img-item">
              <div className="descript-img">
                <img src="//files.authing.co/authing-blog/auting-qrcode.png" alt="authing descript" />
              </div>
              <div className="img-name">
                <p>{t("common.about.qrcodePublic")}</p>
              </div>
            </div>
            <div className="descript-img-item">
              <div className="descript-img">
                <img src="//files.authing.co/authing-website/customer-qrcode.png" alt="authing descript" />
              </div>
              <div className="img-name">
                <p>{t("common.about.qrcodeBusiness")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
